<template>
    <div class="edc">
      <div class="container">
            <el-row :gutter="20">
                <el-col :span="24">
                    <h3>全力打造面向多租户的综合性一站式药物警戒服务</h3>
                    <p>iTrial PVS基于自研低代码平台打造,具备较强的灵活性和配置性,支持对ICSR(个例报告)从创建、审核、冻结到上报的全生命周期的管理。</p>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_1.svg">
						</div>
						<h5>全局总览</h5>
						<p class="text-center">总览视图,统计报告的状态分布和趋势图。 </p>
					</div>
                </el-col>
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_2.svg">
						</div>
						<h5>报告总览视图</h5>
						<p class="text-center">ICSR报告列表,多权限统一管理。 </p>
					</div>
                </el-col>
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/vms_ico_3.svg">
						</div>
						<h5>报告录入与审核</h5>
						<p class="text-center">符合E2B(R3)规范的个例报告录入;支持报告的多级审核、质疑处理;支持自动递交CDE gateway网关。 </p>
					</div>
                </el-col>
                <el-col :span="6">
                    <div class="single-service-inner">
						<div class="thumb text-center">
							<img src="@/assets/img/pro/mda_ico_4.svg">
						</div>
						<h5>可选的审核流程</h5>
						<p class="text-center">从个例报告录入、审核、医学审核及锁定、上报的全流程管理,支持简约和增强两种流程。 </p>
					</div>
                </el-col>
                
          </el-row>
          <section class="program-content">
                <el-row :gutter="20" style="margin-bottom:20px;">
                    <el-col :span="12">
                        <img src="@/assets/img/pro/pvs_img_1.jpg">
                    </el-col>
                    <el-col :span="12">
                        <div class="program-des">
                            <h4>总览视图，统计报告的状态分布和趋势图</h4>
                            <h6>以报告为中心的总览视图</h6>
                            <p>对报告状态分布的统计</p>
                            <p>对报告质疑的统计</p>
                            <p>基于项目或产品视角报告的数据统计</p>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px;">
                    <el-col :span="8">
                        <div class="program-des">
                            <h4>产品维护与管理</h4>
							<h6>多视图产品管理</h6>
                            <p>图表视图：重在产品当前概要信息和报告信息的展示</p>
                            <p>列表视图：重在产品的明细信息的展示与管理</p>
                        </div>
                    </el-col>
                    <el-col :span="16">
                        <img src="@/assets/img/pro/pvs_img_2.jpg">
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px;">
                    <el-col :span="16">
                        <img src="@/assets/img/pro/pvs_img_3.jpg">
                    </el-col>
                    <el-col :span="8">
                        <div class="program-des">
							<h4>个例报告列表</h4>
							<h6>以报告为中心的列表视图</h6>
                            <p>多权限视角(PVO, PVA/SPVA, PVMA, PVM)</p>
                            <p>列表视图:重在产品的明细信息的展示与管理</p>
						</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px;">
                    <el-col :span="8">
                        <div class="program-des">
                            <h4>符合E2B规范的个例报告录入</h4>
							<h6>具人性化的个例报告录入界面</h6>
                            <p>支持多种规范的报告录入</p>
                            <p>人性化数据自动保存与校验提示</p>
                            <p>自动前端缓存机制，不担心浏览器崩溃或数据丢失</p>
                        </div>
                    </el-col>
                    <el-col :span="16">
                        <img src="@/assets/img/pro/pvs_img_4.jpg">
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px;">
                    <el-col :span="16">
                        <img src="@/assets/img/pro/pvs_img_5.jpg">
                    </el-col>
                    <el-col :span="8">
                        <div class="program-des">
							<h4>报告的审核与质疑</h4>
							<h6>报告的审核与质疑</h6>
                            <p>PVA/SPVA审核时可发起质疑</p>
                            <p>质疑的粒度到字段级别</p>
						</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:20px;">
                    <el-col :span="8">
                        <div class="program-des">
                            <h4>可选的多级审核流程</h4>
							<h6>简约的审核流程配置</h6>
                            <p>PV审核流程配置、多种可选流程</p>
                            <p>面向PVA/SPVA, PVMA角色的表单级审核权限配置</p>
                        </div>
                    </el-col>
                    <el-col :span="16">
                        <img src="@/assets/img/pro/pvs_img_6.jpg">
                    </el-col>
                </el-row>
          </section>
      </div>
    </div>
</template>
<script>

export default{
    data() {
        return {

        };
    },
    methods: {
      
    }
}
</script>
<style scoped>
.program-des {
    padding: 60px 30px 0;
    text-align: center;
}
.program-des h4{
  margin-bottom: 30px;
}
.single-service-inner {
  position: relative;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 30px;
  /*box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.1);*/
  transition: all 0.4s ease-in;
  /*clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);*/
  padding: 70px 10px 30px;
}
.page-service-area .single-service-inner {
  padding: 20px ;
}
.single-service-inner.style-2 {
  padding: 40px 40px 50px;
}
.single-service-inner.style-2 .thumb {
  margin-bottom: 23px;
}
.single-service-inner.style-2 .thumb img {
  width: auto;
}
.single-service-inner:hover {
  box-shadow: 0px 5px 30px rgba(126, 86, 255, 0.2);
}
.single-service-inner .thumb {
  margin-bottom: 35px;
}
.program-adv-area .single-service-inner .thumb img {
  
  max-height: 150px;
}
.single-service-inner h5 {
  margin-bottom: 14px;
  text-align: center;
}
.single-service-inner p {
  transition: all 0.4s ease-in;
}

.service--details-area p {
  font-size: 18px;
}
</style>